<template >
    <div style="background-color:white;padding:2em">
        <!-- <img :src="bayes_theory_pic"> -->
        <h3>1 全概率公式</h3>
        <img :src="bayes_PB">
        <p>A为分类；</p>
        <p>B为特征；</p>
        <p>P(A_i) :第i个分类占比，所有分类占比总和为1；</p>
        <p>P(B|A_i )：第i个分类的某特征概率，条件概率；</p>
        <p>P(B): 所有分类的某特征的总概率；</p>
 
        <h3>2 贝叶斯公式</h3>
        <img :src="bayes_equation">
        <p>P(A):先验概率</p>
        <p>P(B|A):条件概率</p>
        <p>P(B):特征全概率</p>
        <p>P(A|B):后验概率</p>
        <img :src="bayes_equation2">

        <h3>3 贝叶斯分类器(多分类单特征)</h3>
        <img :src="bayes_equation3">
        <h3>4 贝叶斯分类器(多分类多特征)</h3>
        <img :src="bayes_equation4">
        
        <h3>5 拉普拉斯优化</h3>
        <p>当因样本量过小，P(Bi|Aj)特征出现的概率统计值为0时，可做如下优化：</p>
        <img :src="bayes_equation5">
        <p>N 总样本数 </p>
        <p>N(A) 类别数</p>
        <p>N(Aj) 类别Aj的样本数</p>
        <p>N(Bi|Aj) 类别Aj中属性Bi出现的次数</p>
        <p>N(Bi) 属性Bi可能取值的个数</p>



    </div>
</template>

<script>

import bayyes_theory_pic from "~pic/bayes_theory.png"
import bayes_PB from "~pic/bayes_PB.png"
import bayes_equation from "~pic/bayes-equation.png"
import bayes_equation2 from "~pic/bayes-equation2.png"
import bayes_equation3 from "~pic/bayes-equation3.png"
import bayes_equation4 from "~pic/bayes-equation4.png"
import bayes_equation5 from "~pic/bayes-equation5.png"

export default ({
    name:'BayesTheory',
    data(){
        return {
            bayes_theory_pic:bayyes_theory_pic,
            bayes_PB,
            bayes_equation,
            bayes_equation2,
            bayes_equation3,
            bayes_equation4,
            bayes_equation5,
            
        }
    }
})
</script>

<style lang="stylus" scoped>
p
    font-size:smaller;
    text-indent: 2em

h3
    margin-top:1em;

</style>
